import { forwardRef } from "react";
import clsx from "clsx";
import { useShownColorScheme } from "hooks/useShownColorScheme";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  Avatar,
  Group,
  Text,
  UnstyledButton,
  useMantineTheme,
} from "@mantine/core";
import classes from "./UserButton.module.css";
import { useTranslation } from "react-i18next";

interface UserButtonProps extends React.ComponentPropsWithoutRef<"button"> {
  email: string;
}

export const UserButton = forwardRef<HTMLButtonElement, UserButtonProps>(
  ({ email, className, ...rest }: UserButtonProps, ref) => {
    const { t } = useTranslation();
    const theme = useMantineTheme();
    const colorScheme = useShownColorScheme();

    return (
      <UnstyledButton
        ref={ref}
        // The Menu target is given a className too
        className={clsx(classes.button, className)}
        {...rest}
      >
        <Group gap="xs" style={{ flexWrap: "nowrap" }}>
          <Avatar
            variant="light"
            radius="xl"
            color={
              colorScheme === "dark"
                ? theme.colors.violet[2]
                : theme.colors.violet[7]
            }
          />
          <div style={{ flex: 1 }}>
            <Text size="sm" style={{ fontWeight: 500 }}>
              {t("generic.your_account_label")}
            </Text>

            <Text c="dimmed" size="xs">
              {email}
            </Text>
          </div>

          <FontAwesomeIcon icon={faChevronDown} className={classes.icon} />
        </Group>
      </UnstyledButton>
    );
  }
);

UserButton.displayName = "UserButton";
